import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { dispatchError } from 'utils/dispatchError';

import { decryptResponse } from 'utils/token';

type GetOperationDocumentsProps = {
  operationId: string;
};

export const getOperationDocuments =
  ({ operationId }: GetOperationDocumentsProps) =>
  async (dispatch: Dispatch) => {
    const query = { params: { operationId } };
    try {
      const { data } = await axiosV2.get(`/operations/documents`, query);

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };
